const gtxLoggedUser = require('./gtx-logged-user');
const gtxConstants = require('./gtx-constants');

const appCuesInit = function() {
    const language = gtxConstants('DEFAULT_LANG');
    const userName = gtxLoggedUser('name');
    const userSurname = gtxLoggedUser('surname');
    const userEmail = gtxLoggedUser('email');
    const agentUuid = gtxLoggedUser('agentUuid');
    const agencyId = gtxLoggedUser('agencyId');

    window.AppcuesSettings = {
        enableURLDetection: true
    };
    
    // Append script to body
    let appCuesScriptElement = document.createElement('script');
    appCuesScriptElement.src = 'https://fast.appcues.com/140570.js';
    appCuesScriptElement.defer = true;
    document.body.appendChild(appCuesScriptElement);

    // Base Appcues config (append `?hey_appcues` to any URL to see if it's working)
    appCuesScriptElement.onload = function() {
        window.Appcues.identify(agentUuid, {
            first_name: userName,
            agencyId: agencyId,
            last_name : userSurname,
            email : userEmail,
            language: language
        });
    }
}

exports.appCuesInit = appCuesInit;
